$(document).ready(function(){

     

        $('.he_product-variant-box').click(function () {
            $('.he_product-variant-box').removeClass('active');
            $(this).addClass('active');

            var currentId = $(this).attr('data-id');

            updateVariantInURL(currentId);
        });

        function updateVariantInURL(variantId) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variantId);
            window.history.replaceState({}, '', url);
        }


        $('.he_product-sub-btn').click(function(){
            $(this).toggleClass('active');

            $('.he_product-variant-perbottle-price').addClass('hided');
            $('.he_product-price-box').addClass('hided');
            if ($(this).hasClass('active')){
                $('.he_product-variant-perbottle-price[data="sub"]').removeClass('hided');
                $('.he_product-price-box[data="sub"]').removeClass('hided');
                $('[data="sub"]').removeClass('hided');
                $('[data="otp"]').addClass('hided');
            }
            else{
                $('.he_product-variant-perbottle-price[data="otp"]').removeClass('hided');
                $('.he_product-price-box[data="otp"]').removeClass('hided');
                $('[data="sub"]').addClass('hided');
                $('[data="otp"]').removeClass('hided');
            }
        });

        $('#shopify-section-template--29723669397852__product .he_product-faq-block').click(function(){
            $(this).find('.he_product-faq-content').slideToggle();
        });

        $('.he_product-cta').click(function(evt){
            evt.preventDefault();

            $('html, body').animate({
                scrollTop: $(".he_product-section").offset().top
            }, 500);
        });

        fetch("https://ipapi.co/json/")
            .then(res => res.json())
            .then(data => {
                const country = data.country_name || "your country";
                const countryCode = data.country_code || "US";

                // Generate flag emoji (based on ISO country code)
                const flag = countryCode
                .toUpperCase()
                .replace(/./g, char => String.fromCodePoint(127397 + char.charCodeAt()));

                // Example date logic (optional)
                const d = new Date();
                d.setDate(d.getDate() + 2);
                const options = { weekday: "long", month: "short", day: "numeric" };
                const formatted = d.toLocaleDateString("en-US", options);

                // Render message
                $(".he_product-delivery-date").html(
                `Get It Quick: Fast Shipping Available to ${country} ${flag}`
                );
            })
            .catch(() => {
                $(".he_product-delivery-date").text("Get It Quick: Fast Shipping Available Worldwide 🌍");
            });


        $('.he_nutri-popup-close').click(function(){
            $('.he_nutri-popup').hide();
        });

        $('.he_product-lab-btn').click(function(evt){
            var mode = $(this).attr('data');
            if (mode == 'expand'){
                evt.preventDefault();
                $('.heproduct-discover-yout-content').slideDown();
            }

            $('.he_nutri-main-image').removeClass('hided');
            $('.he_nutri-faq-image').addClass('hided');

            if (mode == 'popup'){
                 evt.preventDefault();
                $('.he_nutri-popup').css('display', 'flex');
            }

            if (mode == 'close'){
                evt.preventDefault();
                $('.heproduct-discover-yout-content').slideUp();
            }
        });

        $('.he_product-tag').click(function(){
            $('.he_product-tag').removeClass('active');
            $(this).addClass('active');

            var currentTitle = $(this).html();
            var currentText = $(this).attr('data-text');
            $('.he_product-lab-note').find('h3').html(currentTitle);
            $('.he_product-lab-note').find('p').html(currentText);
        });

        $('.he_product-more-info-btn').click(function(evt){
            evt.preventDefault();
            $('.he_product-info-more-content').slideToggle();
        });

       var index = 0;

        $('.he_prod_rev-next_mob').on('click', function () {
            var slideW = $('.he_product-review-slider_mob-in > div').outerWidth(true);
            var slides = $('.he_product-review-slider_mob-in > div').length;

            if (index < slides - 1) index++;

            $('.he_product-review-slider_mob-in').css({
                transform: 'translateX(' + -(index * slideW) + 'px)',
                transition: 'transform .3s ease'
            });
        });

        $('.he_prod_rev-prev_mob').on('click', function () {
            var slideW = $('.he_product-review-slider_mob-in > div').outerWidth(true);

            if (index > 0) index--;

            $('.he_product-review-slider_mob-in').css({
                transform: 'translateX(' + -(index * slideW) + 'px)',
                transition: 'transform .3s ease'
            });
        });

        $('.he_product-main-lab-popup').click(function(){
            var currentSrc = $(this).attr('src');
            $('.he_nutri-popup').css('display', 'flex');
            $('.he_nutri-main-image').addClass('hided');
            $('.he_nutri-faq-image').removeClass('hided');
            $('.he_nutri-faq-image').attr('src', currentSrc);
        });


        $('.he_product-variant-line_outer').click(function(){
            $('.he_product-variant-line_outer').removeClass('active');
            $(this).addClass('active');
        });

        $('.he_product-long-tabs-nav-btn').click(function(){
            $('.he_product-long-tabs-nav-btn').removeClass('active');
            $(this).addClass('active');
            var currentData = $(this).attr('data');
            $('.he_product-long-tabs-content').removeClass('active');
            $('.he_product-long-tabs-content[data="'+currentData+'"]').addClass('active');
        });

        $('.he_mobile-gallery').on('afterChange', function (event, slick, currentSlide) {
            const $dotsWrapper = $(this).find('.slick-dots');
            const $activeDot = $dotsWrapper.find('li.slick-active');

            if (!$activeDot.length) return;

            const wrapper = $dotsWrapper[0];
            const dot = $activeDot[0];

            const wrapperLeft = wrapper.scrollLeft;
            const wrapperRight = wrapperLeft + wrapper.offsetWidth;

            const dotLeft = dot.offsetLeft;
            const dotRight = dotLeft + dot.offsetWidth;

            // If active dot is out of view, scroll to it
            if (dotLeft < wrapperLeft || dotRight > wrapperRight) {
                $dotsWrapper.animate({
                    scrollLeft: dotLeft - wrapper.offsetWidth / 2 + dot.offsetWidth / 2
                }, 300);
            }
        });
        

        $('.he_product-review-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 3000
        });

        $('.he_prod_rev-next').click(function(){
            $('.he_product-review-slider .slick-next').trigger('click');
        });

        $('.he_prod_rev-prev').click(function(){
            $('.he_product-review-slider .slick-prev').trigger('click');
        });

        $('.he_mobile-gallery').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            asNavFor: '.he_mobile-gallery-thumbs'
        });

        $('.he_mobile-gallery-thumbs').slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            asNavFor: '.he_mobile-gallery',
            focusOnSelect: true
        });

        $('.he_desktop-gallery').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            asNavFor: '.he_desktop-gallery_thumbs'
        });

        $('.he_desktop-gallery_thumbs').slick({
            infinite: true,
            slidesToShow: 8,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            focusOnSelect: true,
            asNavFor: '.he_desktop-gallery'
        });

        $('.he_desk-gallery-next').click(function(){
            $('.he_desktop-gallery').find('.slick-next').trigger('click');
        });

        $('.he_desk-gallery-prev').click(function(){
            $('.he_desktop-gallery').find('.slick-prev').trigger('click');
        });

        $('.he_mob-gallery-next').click(function(){
            $('.he_mobile-gallery').find('.slick-next').trigger('click');
        });

        $('.he_mob-gallery-prev').click(function(){
            $('.he_mobile-gallery').find('.slick-prev').trigger('click');
        });

       

    });